<template>
    <h2>PROJECTS</h2>
    <div class="grid-container">
        <button class="imageButton" id="networkProject" @click="$router.push('/NetworkProject')">
            <div class="overlay">
                <span class="imageButtonText">Networking library</span>
            </div>
        </button>
        <button class="imageButton" id="spiteProject" @click="$router.push('/Spite')">
            <div class="overlay">
                <span class="imageButtonText">Spite: Fractured Shards</span>
            </div>
        </button>
        <button class="imageButton" id="driftwoodProject" @click="$router.push('/Driftwood')">
            <div class="overlay">
                <span class="imageButtonText">Driftwood</span>
            </div>
        </button>

    </div>
</template>

<script>
export default {
    name: 'ButtonGrid',
    data() {
        return {
            show: true
        };
    },
methods: {
        toggle() {
            this.show = !this.show;
        }
    }
};
</script>

<style scoped>

.imageButton{
    background-image: url(https://media3.giphy.com/media/JsiGjJayQYjDwVN1Xi/giphy.gif);
    background-size: 100%;
    height: 300px;
    width: 100%;
    border: none;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
}
.imageButton:hover > .overlay{
    width:100%;
    height:100%;
    background-color:#0000003b;
    display: block;
}

.imageButton:hover .imageButtonText{
    visibility: visible;
    opacity:1;
}

.imageButton .imageButtonText{
    position: relative;
    top: 40%;
    visibility: hidden;
    text-align: center;
    font-size: 72px;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    opacity:0;
    font-family: 'Source Sans Pro';
    color: #eddbb2;
    transition: opacity 0.6s;
}

.grid-container{
    display: grid;
}

#networkProject
{
    grid-column: 1 / span 2;
    grid-row: 1;
    background-image: url(/Networkthumb.png);
    background-position-y: 40%;
}
#spiteProject
{
    background-image: url(/Spitethumb.jpg);
    grid-column: 1;
    grid-row: 2;
}
#driftwoodProject
{
    background-image: url(/Driftwoodthumb.png);
    grid-column: 2;
    grid-row: 2;
}

h2{
  position: relative;
  top: 30px;
  padding: 0 0;
  margin: 0 0;
  text-align: left;
  font-size: 3vw;
  z-index: 1;
}

</style>